import React from 'react';
import { Radio } from 'antd';
import { RadioChangeEvent } from 'antd/lib/radio';
import { Answers } from './suppliers-management-locations-update-steps';

type Props = {
  answers?: Answers;
  onAnswer: (value: Answers) => void;
};

export function SuppliersManagementLocationsUpdateStepActiveItems({
  answers,
  onAnswer,
}: Props) {
  return (
    <div className="supplier-management-locations-update-step-active-items">
      <ol>
        <li className="supplier-management-locations-update-step-active-item-li">
          <div>
            Reject all active <span className="text-heavy">Submissions</span>?
          </div>
          <Radio.Group
            value={answers?.rejectSubmissions}
            onChange={(e: RadioChangeEvent) =>
              onAnswer({ ...answers, rejectSubmissions: e.target.value })
            }
          >
            <Radio value={true}>Yes, reject</Radio>
            <Radio value={false}>No, keep as-is</Radio>
          </Radio.Group>
        </li>
        <li className="supplier-management-locations-update-step-active-item-li">
          <div>
            Retract all pending <span className="text-heavy">Offers</span>?
          </div>
          <Radio.Group
            value={answers?.retractOffers}
            onChange={(e: RadioChangeEvent) =>
              onAnswer({ ...answers, retractOffers: e.target.value })
            }
          >
            <Radio value={true}>Yes, retract</Radio>
            <Radio value={false}>No, keep as-is</Radio>
          </Radio.Group>
        </li>
        <li className="supplier-management-locations-update-step-active-item-li">
          <div>
            Retract all pending{' '}
            <span className="text-heavy">Extension Offers</span>?
          </div>
          <Radio.Group
            value={answers?.retractExtensionOffers}
            onChange={(e: RadioChangeEvent) =>
              onAnswer({ ...answers, retractExtensionOffers: e.target.value })
            }
          >
            <Radio value={true}>Yes, retract</Radio>
            <Radio value={false}>No, keep as-is</Radio>
          </Radio.Group>
        </li>
      </ol>
      <style jsx>{`
        .supplier-management-locations-update-step-active-item-li,
        .supplier-management-locations-update-step-active-item-li
          :global(.ant-radio-wrapper) {
          font-size: 16px;
        }
        .supplier-management-locations-update-step-active-item-li {
          margin-bottom: 24px;
        }
        .supplier-management-locations-update-step-active-items-li
          :global(.ant-radio-group) {
          margin-top: 8px;
        }
      `}</style>
    </div>
  );
}
